import { render, staticRenderFns } from "./Partecipa.vue?vue&type=template&id=d7d89d38&"
import script from "./Partecipa.vue?vue&type=script&lang=js&"
export * from "./Partecipa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports